import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App.tsx';
import './styles.css';

/*
  Nach einem Ausrollen die neue Fassung sofort übernehmen.

  Der Service Worker meldet sich mit skipWaiting und claim sofort zuständig -
  die bereits geladene Seite läuft aber weiter mit dem alten Programmcode. Ohne
  diesen Neuaufbau bekommt man eine Korrektur erst beim ZWEITEN Öffnen zu
  sehen. Genau daran hing ein Fehler, der längst behoben war: Die App schickte
  weiter den alten Feldnamen für Tachofotos.

  Der Wechsel geschieht ein, zwei Sekunden nach dem Öffnen, also bevor jemand
  etwas eingetippt hat. Nur einmal, sonst drehte sich die Seite im Kreis.
*/
if ('serviceWorker' in navigator) {
  let neuGeladen = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (neuGeladen) return;
    neuGeladen = true;
    window.location.reload();
  });
}

createRoot(document.getElementById('wurzel')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
